"use client";

import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "@lib/redux/hooks";
import {
  initializeShortlist,
  selectShortlistInitialized,
  ShortlistCar,
} from "@lib/redux/slices/shortlistSlice";

interface ShortlistInitializerProps {
  initialData: ShortlistCar[];
}

const ShortlistInitializer = ({ initialData }: ShortlistInitializerProps) => {
  const dispatch = useAppDispatch();
  const isShortlistInitialized = useAppSelector(selectShortlistInitialized);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) {
      return;
    }

    if (isShortlistInitialized) {
      hasInitialized.current = true;
      return;
    }

    dispatch(initializeShortlist(initialData));
    hasInitialized.current = true;
  }, [dispatch, initialData, isShortlistInitialized]);

  return null;
};

export default ShortlistInitializer;
